<div
  [id]="mapId"
  class="map"
  style="position: relative; z-index: 0; max-height: 100%; max-width: 100%"
  [ngStyle]="mapId | misc: 'mapHeightCheck'"
></div>
